import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const UPLOADING = '1a275603-3b04-43b4-a17e-65424d78f50c';
export const UPLOADED = '16142dbf-155b-4cff-9747-c2a1967ca915';
export const VALIDATING = 'ddbef627-3e5b-4aca-95bb-dbe2916bebd8';
export const VALID = '26244d4d-b293-4211-8652-01cbee975ec0';
export const INVALID = '61e78727-a29c-447c-8f5e-cf253dfcc1f9';
export const WARNING = '05eac9f2-aa79-4ff8-b7a2-c4249cb65467';
export const PROCESSING = 'edf82dcf-3b40-470c-bcf9-3dd5290c6cd5';
export const IMPORTED = '5d6b1605-25b7-4c58-abfd-93d95e549fe4';

class LuHubImportStatusAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-hub-import-status';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'updated_at',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'slug',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [
        ];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [
        ];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [
        ];
    }

}

export default LuHubImportStatusAppResource;
